import { SecondaryButton } from '../../../global/styles';
import { useGetUserQuery } from '../../../store/apiSlice';
import { StyledProButton } from './styles';

interface Props {
	children: React.ReactNode;
	onClick?: () => void;
}

export default function ProButton({ children, onClick }: Props) {
	const { data: user } = useGetUserQuery();
	const isPro = Boolean(user?.pro);
	return isPro ? (
		<SecondaryButton onClick={onClick}>{children}</SecondaryButton>
	) : (
		<StyledProButton>
			<a href="/features">{children}</a>
		</StyledProButton>
	);
}
